@if (isLoading()) {
    <div *appCardContent>
        <div class="mb-spacing">
            <div class="indent">
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            </div>
        </div>
    </div>
} @else {
    @if (!!form) {
        <form [formGroup]="form">

            <div class="field-row">
                <div class="field-row-title">
                    Rounding option
                </div>
                <div class="field-row-element">
                    <app-row-with-select [list]="hourRoundingOptions" listId="value" listLabel="label"
                                         formControlName="rounding"></app-row-with-select>
                </div>
            </div>
        </form>
    }
}
